var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('h1',[_vm._v(_vm._s(_vm.$t("notFound.title")))]),_c('p',[_vm._v(_vm._s(_vm.$t("notFound.text")))]),_c('img',{attrs:{"src":require("../assets/img/notfound/404-gif.gif"),"alt":"Animated git of a panda destroying a computer","loading":"lazy"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }